import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { commonErrorResponses, requiredPayloadEnvelope } from '../envelope.js';
import { tokenRefreshSchema } from '../common/schemas.js';
/** 로그인한 직원 본인의 프로필이다. presetIds는 여기에 포함하지 않는다. */
const adminProfileSchema = z.object({
    /** AdminUser id다. */
    id: z.string(),
    /** 로그인 이메일이다. */
    email: z.string(),
    /** 표시 이름이다. */
    name: z.string(),
    /** `super_admin` 또는 `admin`이다. */
    role: z.string(),
    /** 임시 비밀번호를 아직 바꾸지 않았으면 true다. */
    isTempPassword: z.boolean(),
});
const c = initContract();
/** admin-api — 로그인한 직원 본인 프로필·비밀번호 변경. */
export const adminUsersProfileContract = c.router({
    /** 현재 로그인한 직원의 프로필을 조회한다. */
    getProfile: {
        method: 'GET',
        path: '/user/profile',
        responses: {
            200: requiredPayloadEnvelope(adminProfileSchema),
            ...commonErrorResponses,
        },
    },
    /** 비밀번호를 변경하고 새 AT를 발급한다. */
    changePassword: {
        method: 'PATCH',
        path: '/user/change-password',
        body: z.object({
            /** 현재 비밀번호다. */
            currentPassword: z.string().optional(),
            /** 새 비밀번호다. */
            newPassword: z.string().optional(),
            /** DPoP proof JWT다. */
            dpopProof: z.string().optional(),
        }),
        responses: {
            200: requiredPayloadEnvelope(tokenRefreshSchema),
            ...commonErrorResponses,
        },
    },
});
export { adminProfileSchema };
//# sourceMappingURL=users.contract.js.map